import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Section from "components/section";
import {
  IconButton,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";

//Styles
import styles from "routes/dashboard/dashboard-styles";
const useStyles = makeStyles(styles);

export default function (props) {
  const classes = useStyles();
  const {
    loading,
    qualifications,
    onPressedDeleteItem,
    sectionDescription,
    toggleAddQualificationForm,
  } = props;

  return (
    <Section
      title="Qualifications"
      loading={loading}
      actionName="Add Qualification"
      handleAction={toggleAddQualificationForm}
      sectionDescription={sectionDescription}
    >
      {qualifications && qualifications.length > 0 && (
        <TableContainer  component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell align="left">
                  <Typography className={classes.labelText}>
                    Qualification
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography className={classes.labelText}>
                    Country Obtained
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  {" "}
                  <Typography className={classes.labelText}></Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {qualifications.map((row, index) => {
                return (
                  <TableRow hover key={row._id} className={classes.row}>
                    <TableCell className={classes.cellName} align="left">
                      {row.content}
                    </TableCell>
                    <TableCell className={classes.cellName} align="left">
                      {row.country}
                    </TableCell>
                    <TableCell className={classes.cellType} align="right">
                      <IconButton
                        aria-label="delete"
                        color="primary"
                        onClick={(event) => {
                          onPressedDeleteItem(index, row.objectID);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {qualifications == null ||
        (qualifications.length === 0 && (
          <Typography className={classes.emptyText} align="center">
            No qualifications assigned to this student
          </Typography>
        ))}
    </Section>
  );
}
